export interface IKeySecret {
  key: string;
  secret: string;
}
